import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * High-conversion CTA button: orange/coral pill with animated rocket emoji.
 * Use anywhere "start trial" / "testar grátis" intent applies.
 *
 * Props:
 *   to: link destination (default "/signup")
 *   label: button text (default "Testar Grátis")
 *   subLabel: optional small line under main label
 *   variant: "primary" (orange filled) | "ghost" (transparent border)
 *   size: "lg" | "md"
 *   testId
 *   className: extra classes
 */
export default function RocketCta({
  to = "/signup",
  label = "Testar Grátis",
  subLabel = null,
  variant = "primary",
  size = "lg",
  testId = "rocket-cta",
  className = "",
}) {
  const sizeClasses =
    size === "lg"
      ? "h-14 px-8 text-base"
      : "h-11 px-6 text-sm";

  const baseClasses =
    variant === "primary"
      ? "bg-primary text-white shadow-[0_10px_30px_-10px_rgba(240,90,63,0.6)] hover:shadow-[0_18px_40px_-10px_rgba(240,90,63,0.85)] hover:-translate-y-0.5 active:translate-y-0 cta-pulse-ring"
      : "border border-primary/40 bg-primary/5 text-primary hover:bg-primary/10";

  return (
    <Link to={to} data-testid={testId} className={`inline-flex justify-center ${className}`}>
      <span
        className={`group relative inline-flex items-center justify-center gap-3 rounded-full font-display font-semibold tracking-tight transition-all duration-300 ${baseClasses} ${sizeClasses}`}
      >
        <span className="rocket-emoji text-xl leading-none transform transition-transform duration-300 group-hover:-rotate-12 group-hover:-translate-y-0.5 group-hover:translate-x-0.5">
          🚀
        </span>
        <span className="flex flex-col items-start leading-tight">
          <span>{label}</span>
          {subLabel && (
            <span className="text-[10px] uppercase tracking-widest font-normal opacity-80">
              {subLabel}
            </span>
          )}
        </span>
        <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
        {variant === "primary" && (
          <span className="absolute inset-0 rounded-full ring-1 ring-white/20 pointer-events-none" />
        )}
      </span>
    </Link>
  );
}
